/*       */

import { gql } from '@apollo/client';
import entityDetailsCommonQuery from 'graphql/entities/common/entityDetailsCommonQuery';

export default gql`
    mutation addEntityMediaMutation(
        $type: String!,
        $id: ID!,
        $mediaName: String!,
        $file: Upload!,
        ) {
        result: addEntityMedia(
            type: $type,
            id: $id,
            mediaName: $mediaName,
            file: $file){
            ${entityDetailsCommonQuery}
        }
    }
`;
